export default "__VITE_ASSET__X0C9RbKb__"